import { render, staticRenderFns } from "./MultipleTextAreas.vue?vue&type=template&id=0ef00153&scoped=true&"
import script from "./MultipleTextAreas.vue?vue&type=script&lang=js&"
export * from "./MultipleTextAreas.vue?vue&type=script&lang=js&"
import style0 from "./MultipleTextAreas.vue?vue&type=style&index=0&id=0ef00153&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef00153",
  null
  
)

/* custom blocks */
import block0 from "./MultipleTextAreas.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports